<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div>
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Grupo: {{ dadosGrupo?.nome }}
        </p>
      </div>
      <div>
        <router-link :to="{ name: 'ferramentaria-cadastro-grupo' }">
          <div
            style="cursor: pointer"
            class="row items-center text-weight-bold text-brand-5 q-mr-md container-link-voltar"
          >
            <q-icon class="q-mr-sm icon-voltar" name="west" color="brand-5" />
            <span class="texto-titulo">Voltar</span>
          </div>
        </router-link>
      </div>
    </div>
    <div
      class="row col-12 q-mt-md items-center q-gutter-sm text-brand-5 text-weight-bold"
    >
      <div v-show="false" class="col-2">
        <div>Unidade</div>
        <ListaUnidadesSelect />
      </div>
      <div class="col-md-2 col-xs-4">
        <div class="texto-titulo-input">Nome do Subgrupo</div>
        <q-input
          class="input-mobile"
          v-model="dados.nomeSubgrupo"
          dense
          outlined
        />
      </div>
      <div class="col-md-4 col-xs-4">
        <div class="texto-titulo-input">Descrição</div>
        <q-input
          class="input-mobile"
          v-model="dados.descricaoSubgrupo"
          dense
          outlined
        />
      </div>
      <div>
        <p></p>
        <q-btn
          color="positive"
          class="q-mt-xs btn"
          label="Criar"
          icon="add"
          no-caps
          @click="criarSubgrupo()"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 justify-between items-center q-mb-sm">
        <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
          Subgrupos Criados
        </div>
        <div class="row col-md-3 col-xs-12 justify-end">
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            type="text"
            class="col-md col-xs-7 input-mobile"
            placeholder="Pesquisar"
            v-model="filtroNome"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <q-linear-progress v-if="loading" indeterminate size="3px" />
      <q-table
        table-header-class="bg-accent text-weight-bold"
        flat
        :columns="columns"
        dense
        :rows="listaSubgruposCriados"
        :hide-bottom="!listaSubgruposCriados.length == 0"
        selection="single"
        v-model:selected="selected"
        row-key="catalogoSubGrupoUuid"
        :rows-per-page-options="[0]"
        :class="{ 'my-sticky-dynamic': !mobile }"
        :grid="mobile"
        no-data-label="Nenhum subgrupo criado"
      >
        <template v-slot:item="props">
          <div class="q-pa-xs row col-12">
            <q-card class="container-grid-table col-12">
              <div class="q-pa-sm">
                <div class="row col-12 items-center">
                  <div class="col-6">
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Nome:</strong>
                      <span v-if="!props.selected"> {{ props.row.nome }}</span>
                      <input
                        v-else
                        v-model="props.row.nome"
                        class="input-mobile-grid row col-12"
                      />
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs q-mt-xs">Descrição:</strong>
                      <span v-if="!props.selected">
                        {{ props.row.descricao }}</span
                      >
                      <input
                        v-else
                        v-model="props.row.descricao"
                        class="input-mobile-grid row col-12"
                      />
                    </div>
                  </div>
                  <div class="col">
                    <div class="row col-12 justify-end no-wrap">
                      <div>
                        <q-btn
                          v-if="!props.selected"
                          icon="edit"
                          flat
                          color="primary"
                          :disable="disable"
                          @click="
                            (props.selected = true),
                              (dadoEditarSubgrupo = { ...props.row })
                          "
                        />
                        <q-btn
                          v-else
                          icon="done"
                          flat
                          round
                          color="positive"
                          :disable="disable"
                          @click="editarSubgrupo(props.row)"
                        />
                      </div>
                      <div>
                        <q-btn
                          icon="delete"
                          flat
                          color="red"
                          :disable="disable"
                          @click="
                            excluirSubgrupo(props.row.catalogoSubGrupoUuid)
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </q-card>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td>
              <span v-if="!props.selected">{{ props.row.nome }}</span>
              <q-input
                class="input"
                v-else
                dense
                outlined
                v-model="props.row.nome"
              />
            </q-td>
            <q-td>
              <span v-if="!props.selected"> {{ props.row.descricao }}</span>
              <q-input
                class="input"
                v-else
                dense
                outlined
                v-model="props.row.descricao"
              />
            </q-td>
            <q-td class="coluna-btn">
              <q-btn
                v-if="!props.selected"
                color="primary"
                icon="edit"
                round
                flat
                :disable="disable"
                @click="
                  (props.selected = true),
                    (dadoEditarSubgrupo = { ...props.row })
                "
              />
              <q-btn
                v-else
                color="positive"
                icon="done"
                round
                flat
                :disable="disable"
                @click="editarSubgrupo(props.row)"
              />
            </q-td>
            <q-td class="coluna-btn">
              <q-btn
                color="red"
                icon="delete"
                round
                flat
                :disable="disable"
                @click="excluirSubgrupo(props.row.catalogoSubGrupoUuid)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div
        v-if="listaSubgruposCriados.length > 0"
        class="row justify-center q-mt-md"
      >
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          :size="mobile ? 'md' : 'sm'"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";

import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

const columns = [
  {
    name: "nomeSubgrupo",
    label: "Nome do Subgrupo",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "editar",
    label: "Editar",
    align: "left",
  },
  {
    name: "excluir",
    label: "Excluir",
    align: "left",
  },
];
export default {
  components: { ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();

    let rightDrawerModalOpen = ref(false);
    const catalogoUuid = salvarCatalogoUuid();
    const listaSubgruposCriados = ref([]);
    const selected = ref([]);
    const grupoUuid = route.params.grupoId;
    const filtroNome = ref("");
    const dadosGrupo = ref();
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    let disable = ref(false);
    const dados = ref({
      nomeSubgrupo: "",
      descricaoSubgrupo: "",
    });
    const dadoEditarSubgrupo = ref();
    let loading = ref(false);
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const detalharGrupo = async () => {
      await store.state.org.unidadeData.id;
      if (catalogoUuid.catalogoUuid.value === null) {
        return;
      }
      try {
        const response = await store.dispatch(
          "ferramentaria/listarGruposCriados",
          {
            unidadeId: store.state.org.unidadeData.id,
            catalogoUuid: catalogoUuid.catalogoUuid.value,
            page: 1,
            catalogoGrupoUuid: grupoUuid,
            per_page: 1,
          }
        );
        dadosGrupo.value = { ...response.data.resultado.dados[0] };
      } catch (error) {
        console.log(error);
      }
    };

    const listarSubgrupoCriados = async (page = 1, rowsPerPage = 10) => {
      disable.value = true;
      loading.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/listarSubgrupoGrupo",
          {
            catalogoGrupoUuid: grupoUuid,
            page: page,
            perPage: mobile.value ? 5 : rowsPerPage,
            nome: filtroNome.value,
          }
        );
        listaSubgruposCriados.value = response.data.resultado.dados;
        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.data.resultado.total;
        pagination.value.rowsPerPage = response.data.resultado.perPage;
        disable.value = false;
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const criarSubgrupo = async () => {
      if (dados.value.nomeSubgrupo === "") {
        quasar.notify({
          message: "O nome do subgrupo é obrigatório.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (dados.value.descricaoSubgrupo === "") {
        quasar.notify({
          message: "A descrição do subgrupo é obrigatória.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("ferramentaria/criarSubgrupo", {
          catalogoGrupoUuid: grupoUuid,
          nome: dados.value.nomeSubgrupo,
          descricao: dados.value.descricaoSubgrupo,
          usuarioId: store.state.autenticacao.usuarioLogado.id,
          usuarioNome: store.state.autenticacao.usuarioLogado.nome,
        });
        quasar.notify({
          message: "Subgrupo criado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarSubgrupoCriados();
        resetVariaveis();
      } catch (error) {
        quasar.notify({
          message: error.response.data.erros.mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const editarSubgrupo = async (subgrupo) => {
      if (subgrupo.nome === "") {
        quasar.notify({
          message: "O nome do subgrupo é obrigatório.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (subgrupo.descricao === "") {
        quasar.notify({
          message: "A descrição do subgrupo é obrigatória.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (
        subgrupo.nome === dadoEditarSubgrupo.value.nome &&
        subgrupo.descricao === dadoEditarSubgrupo.value.descricao
      ) {
        selected.value = [];
        return;
      }

      try {
        await store.dispatch("ferramentaria/editarSubgrupo", {
          catalogoSubGrupoUuid: subgrupo.catalogoSubGrupoUuid,
          nome: subgrupo.nome,
          descricao: subgrupo.descricao,
        });
        quasar.notify({
          message: "Subgrupo editado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarSubgrupoCriados();
        selected.value = [];
      } catch (error) {
        quasar.notify({
          message: error.response.data.erros.mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const excluirSubgrupo = async (catalogoSubGrupoUuid) => {
      try {
        await store.dispatch("ferramentaria/deletarSubgrupo", {
          catalogoSubGrupoUuid,
        });
        quasar.notify({
          message: "Subgrupo excluido com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarSubgrupoCriados();
      } catch (error) {
        quasar.notify({
          message: error.response.data.erros.mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const resetVariaveis = () => {
      dados.value = {
        nomeSubgrupo: "",
        descricaoSubgrupo: "",
      };
    };

    watch(
      () => catalogoUuid.catalogoUuid.value,
      () => {
        detalharGrupo();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarSubgrupoCriados(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }
    );

    watch(
      () => filtroNome.value,
      () => {
        listarSubgrupoCriados();
      }
    );

    onMounted(() => {
      detalharGrupo();
      listarSubgrupoCriados();
    });

    return {
      columns,
      rightDrawerModalOpen,
      listaSubgruposCriados,
      listarSubgrupoCriados,
      selected,
      grupoUuid,
      dadosGrupo,
      detalharGrupo,
      pagination,
      loading,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      criarSubgrupo,
      dados,
      resetVariaveis,
      dadoEditarSubgrupo,
      editarSubgrupo,
      filtroNome,
      excluirSubgrupo,
      mobile,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
.input {
  width: 180px;
}
tbody tr .coluna-btn {
  width: 120px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
.texto-titulo {
  font-size: 20px;
}
.icon-voltar {
  font-size: 25px;
}
.container-link-voltar {
  margin-right: 10px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.titulo-tabela {
  font-size: 18px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .btn {
    font-size: 12px;
    margin-bottom: 2px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .input-mobile {
    font-size: 12px;
  }

  .input-mobile-grid {
    width: 100%;
    outline: none;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
}
</style>
